module.exports = __webpack_public_path__ + "img/leafIcon.cb376bef.png";